<template>
  <div id="training-page" class='training-home-component'>

    <div id="training-wave" class='training-waves-container'>
      <img class='training-wave-left' src='@/assets/home/training-wave-left.png'/>
      <img class='training-wave-right' src='@/assets/home/training-wave-right.png'/>
    </div>

    <div id="training-content" class="page-container">

      <div fade class='training-title'>NOS FORMATIONS</div>
      <div fade class='training-underline'></div>

      <div fade class='training-infos-container'>
        <div class='training-info-container' v-for='(info,index) in infos' :key='index'>
          <div class='training-info-rhombus-container'>
            <div class='training-info-rhombus'>
              <div class='training-info-border' :style="{'--icon-step':info.iconStep, '--animation-duration':info.animationDuration+'s', '--icon-last-position':-info.iconStep*80+'px'}">
                <div class="image" :style="{'background-image':`url(${info.icon})`}"/>
              </div>
            </div>
          </div>
          <div class='training-info-title'>{{ info.title }}</div>
          <div class='training-info-separate-border'></div>
          <div class='training-info-text' v-html="info.text"></div>
        </div>
      </div>

      <div fade class='training-stacks-container'>
        <div class='training-stack-container' v-for="(training, index) in trainings.slice(0, 4)"
          :key="index" @click="openDescription(training)">
          <div class='training-stack-icon-container'>
            <img class='training-stack-icon' :src='training.logo'/>
          </div>
          <div class='training-stack-title-container'>
            <div class='training-stack-title'>{{ training.name }}</div>
          </div>
          <div class='training-stack-seperate'></div>
          <div class='training-stack-text-container'>
            <div class='training-stack-text'>{{ training.subtitle }}</div>
          </div>
          <div class='training-stack-button-container'>
            <button class='training-stack-button'>
              <p class='training-stack-button-text'>DÉCOUVRIR</p>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'TrainingHomeComponent',

  props: ['controller', 'trainings', 'infos'],

  methods: {

    openDescription ({ name }) {
      this.$router.push({ name: 'TrainingPage', params: { trainingName: name, mode: 'description' } })
    },

    initContentScene () {
      const fades = this.$el.querySelectorAll('[fade]')

      gsap.set(fades, { autoAlpha: 0, y: 100 })
      gsap.set('#training-wave', { autoAlpha: 0 })

      const fadeIn = gsap.timeline({
        scrollTrigger: {
          trigger: '#training-page',
          start: 'top 70%'
        }
      })
      fadeIn
        .to(fades, { duration: 0.8, autoAlpha: 1, stagger: 0.2 }, 'd')
        .to('#training-wave', { duration: 2, autoAlpha: 1 }, 'd')

      const parralax = gsap.timeline({
        scrollTrigger: {
          trigger: '#training-page',
          start: 'top center',
          end: '+=' + (typeof window !== 'undefined' ? window.innerHeight * 0.8 : 800),
          scrub: true
        }
      })
      parralax
        .to('#training-wave', { y: '-=256', ease: 'none' }, 0)
        .to('#training-content', { y: '-=100', ease: 'none' }, 0)
    }
  },

  mounted () {
    this.initContentScene()
  }

}
</script>

<style lang='scss'>

.page-container {
  max-width: 1400px;
  width: 100%;

  @include media(phone) {
    padding: 42px 0;
  }
}

.training-home-component {
  display: flex;
  flex: column;
  justify-content: center;
  align-items: center;

  height: 100vh;
  min-height: 1080px;

  position: relative;

  padding: 0 64px;

  @include media(tablet) {
    padding: 0;
  }

  @include media(phone) {
    padding: 32px 0;
    height: unset;
  }

  .training-title {
    @extend %default-title;

    margin-bottom: 14px;

    @include media(tablet) {
      margin-left: 64px;
    }

    @include media(phone) {
      margin: 0 32px;
      margin-bottom: 14px;
    }
  }

  .training-underline {
    @extend %default-underline;
    margin-right: 64px;

    @include media(tablet) {
      margin-left: 64px;
    }

    @include media(phone) {
      margin-left: 32px;
    }
  }

  .training-waves-container {
    position: absolute;

    align-self: center;
    grid-column: 1;
    grid-row: 2;
    width: 100%;
    @include media(1200px) {
      .training-wave-left,.training-wave-right  {
        display: none;
      }
    }
    $wave_height: 256px;
    .training-wave-left {
      float: left;
      height: $wave_height;
    }

    .training-wave-right {
      float: right;
      height: $wave_height;
    }
  }

  .training-infos-container {
    align-items: center;
    display: flex;
    grid-column: 1;
    grid-row: 2;
    justify-content: space-around;
    margin: 0px auto;
    width: 75%;
    height: 354px;

    @include media(phone) {
      height: unset;
      flex-direction: column;
    }

    @include media(tablet) {
      width: 90%;
    }

    .training-info-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 256px;

      @include media(phone) {
        margin-bottom: 64px;
      }

      .training-info-rhombus-container {

        user-select: none;

        .training-info-rhombus {
          background-color: #B98A30;
          text-align: center;

          transform: rotate(45deg);
          transform-origin: center center;

          height: 150px;
          width: 150px;

          border-radius: 4px;
        }

        .training-info-border {
          display: flex;
          justify-content: center;
          align-items: center;

          position: absolute;

          top: 6px;
          left: 6px;

          height: 135px;
          width: 135px;

          border: 1px solid #FFFFFF;

          @keyframes play {
            100% { background-position: var(--icon-last-position); }
          }
          .image {
            position: absolute;
            width: 80px;
            height: 80px;
            transform: rotate(-45deg);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: left center;
            animation: play var(--animation-duration) steps(var(--icon-step)) infinite;
          }
        }
      }

      .training-info-title {
        color: #494949;
        font-weight: 600;
        letter-spacing: -0.04px;
        padding-top: 54px;
        text-align: center;
      }

      .training-info-separate-border {
        border-bottom: 1px solid #494949;
        margin: 0px auto;
        margin-top: 5%;
        margin-bottom: 5%;
        width: 50%;
      }

      .training-info-text {
        color: #494949;
        font-weight: 300;
        letter-spacing: -0.04px;
        line-height: 24px;
        text-align: center;
      }
    }
  }

  .training-stacks-container {
    display: flex;
    justify-content: space-around;

    padding-top: 48px;
    text-align: center;

    height: 374px;

    @include media(tablet) {
      flex-direction: column;
      align-items: center;
      height: unset;
      width: 100%;
      overflow: scroll;

      flex-direction: row;
      flex-shrink: 0;
      justify-content: unset;
    }

    .training-stack-container {
      align-items: center;
      background-color: #FFFFFF;
      border: 4px solid #B98A30;
      border-radius: 4px;
      box-shadow: 0 2px 9px 0 rgba(124,124,124,0.5);
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: 30% 15% 5% 25% 25%;
      height: 90%;
      width: 228px;
      min-width: 228px;

      transform: scale(1);
      transition: transform 0.3s ease;

      cursor: pointer;

      &:hover {
        transform: scale(1.02);
      }

      @include media(tablet) {
        height: 375px;

        margin: 0 16px;
        margin-bottom: 35px;
      }

      .training-stack-icon-container {
        grid-column: 1;
        grid-row: 1;
        width: 100%;

        user-select: none;

        .training-stack-icon {
          height: 100%;
          padding-top: 20px;
          width: 25%;

          &:first-child {
            width: 25%;
          }
        }
      }

      .training-stack-title-container {
        color: #494949;
        display: flex;
        font-size: 1.5rem;
        font-weight: bold;
        grid-column: 1;
        grid-row: 2;
        justify-content: center;
        letter-spacing: -0.02px;

        text-transform: uppercase;
      }

      .training-stack-seperate {
        border-bottom: 1px solid #494949;
        grid-column: 1;
        grid-row: 3;
        margin: 0 auto;
        width: 50%;
      }

      .training-stack-text-container {
        color: #494949;
        display: flex;
        font-size: 0.9rem;
        font-weight: 300;
        grid-column: 1;
        grid-row: 4;
        text-align: center;
        justify-content: center;
        letter-spacing: -0.05px;
        line-height: 18px;
        width: 100%;
        overflow: hidden;
        padding: 0 8px;
        box-sizing: border-box;

        .training-stack-text {
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }

      .training-stack-button-container {
        display: flex;
        grid-column: 1;
        grid-row: 5;
        justify-content: center;

        .training-stack-button {
          @extend %default-button;
        }
      }
    }
  }
}
</style>
